import { defineMessages } from "@formatjs/intl"
import type { VehicleType } from "./VehicleType"

export const vehicleTypeMessages = defineMessages<VehicleType>({
	COMMISSION_CAR: {
		defaultMessage: "Commission Car",
		id: "vehicle.vehicleType.commissionCar",
	},
	COMPANY_CAR: {
		defaultMessage: "Company Car",
		id: "vehicle.vehicleType.companyCar",
	},
	CUSTOMER_REPLACEMENT_CAR: {
		defaultMessage: "Customer Replacement Car",
		id: "vehicle.vehicleType.customerReplacementCar",
	},
	DEMO_CAR: {
		defaultMessage: "Demo Car",
		id: "vehicle.vehicleType.demoCar",
	},
	NEW_CAR: {
		defaultMessage: "New Car",
		id: "vehicle.vehicleType.newCar",
	},
	USED_CAR: {
		defaultMessage: "Used Car",
		id: "vehicle.vehicleType.usedCar",
	},
})
